import {
  AsurionDoodleSpinner,
  DoodleSpinnerProps,
} from '@asurion-core/mx-asurion-ui-react';
import styles from './CenteredLoadingSpinner.module.css';

interface CenteredLoadingSpinnerProps extends DoodleSpinnerProps {}

export function CenteredLoadingSpinner(props: CenteredLoadingSpinnerProps) {
  return (
    <div className={styles.loaderContainer}>
      <AsurionDoodleSpinner {...props} />
    </div>
  );
}
